<template>
  <el-dialog
    v-model="dialogVisible"
    title="立即预约"
    width="500px"
    :close-on-click-modal="false"
    class="booking-dialog"
  >
    <el-form
      ref="formRef"
      :model="form"
      :rules="rules"
      label-position="right"
      label-width="80px"
      class="booking-form"
    >
      <el-form-item label="姓名" prop="customerName" required>
        <el-input 
          v-model="form.customerName" 
          placeholder="请输入您的姓名"
          maxlength="50"
        />
      </el-form-item>
      
      <el-form-item label="单位" prop="company" required>
        <el-input 
          v-model="form.company" 
          placeholder="请输入您的单位"
          maxlength="100"
        />
      </el-form-item>
      
      <el-form-item label="手机号" prop="phone" required>
        <el-input 
          v-model="form.phone" 
          placeholder="请输入您的手机号"
          maxlength="20"
        />
      </el-form-item>
      
      <el-form-item label="计算材料" prop="material" required>
        <el-input 
          v-model="form.material" 
          placeholder="请输入计算材料"
          maxlength="255"
        />
      </el-form-item>
      
      <el-form-item label="计算要求" prop="requirements" required>
        <el-input 
          v-model="form.requirements" 
          type="textarea"
          :rows="3"
          placeholder="请输入计算要求"
          maxlength="500"
          show-word-limit
        />
      </el-form-item>
    </el-form>
    
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="handleCancel">取消</el-button>
        <el-button type="primary" @click="handleSubmit" :loading="submitting">提交</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, watch } from 'vue'
import { ElMessage } from 'element-plus'
import { submitBooking } from '@/api/product'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false
  },
  product: {
    type: Object,
    default: () => ({})
  }
})

const emit = defineEmits(['update:visible', 'success'])

const dialogVisible = ref(false)
const formRef = ref(null)
const submitting = ref(false)

const form = ref({
  customerName: '',
  company: '',
  phone: '',
  material: '',
  requirements: ''
})

const rules = {
  customerName: [
    { required: true, message: '请输入姓名', trigger: 'blur' },
    { min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
  ],
  company: [
    { required: true, message: '请输入单位', trigger: 'blur' },
    { min: 2, max: 100, message: '长度在 2 到 100 个字符', trigger: 'blur' }
  ],
  phone: [
    { required: true, message: '请输入手机号', trigger: 'blur' },
    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
  ],
  material: [
    { required: true, message: '请输入计算材料', trigger: 'blur' }
  ],
  requirements: [
    { required: true, message: '请输入计算要求', trigger: 'blur' }
  ]
}

watch(() => props.visible, (val) => {
  dialogVisible.value = val
  if (val) {
    resetForm()
  }
})

watch(() => dialogVisible.value, (val) => {
  emit('update:visible', val)
})

const resetForm = () => {
  form.value = {
    customerName: '',
    company: '',
    phone: '',
    material: '',
    requirements: ''
  }
  if (formRef.value) {
    formRef.value.resetFields()
  }
}

const handleCancel = () => {
  dialogVisible.value = false
}

const handleSubmit = async () => {
  if (!formRef.value) return
  
  await formRef.value.validate(async (valid) => {
    if (valid) {
      submitting.value = true
      try {
        const data = {
          ...form.value,
          productId: props.product?.productId || 1,
          productName: props.product?.productName || '多功能通用无人机H1'
        }
        
        const res = await submitBooking(data)
        if (res.code === 200) {
          ElMessage.success('预约提交成功！')
          dialogVisible.value = false
          emit('success')
        } else {
          ElMessage.error(res.msg || '预约提交失败')
        }
      } catch (error) {
        console.error('提交预约失败:', error)
        ElMessage.error('预约提交失败，请稍后重试')
      } finally {
        submitting.value = false
      }
    }
  })
}
</script>

<style scoped>
.booking-dialog :deep(.el-dialog__header) {
  text-align: center;
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 20px;
}

.booking-dialog :deep(.el-dialog__title) {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.booking-form {
  padding: 20px 10px 0;
}

.booking-form :deep(.el-form-item__label) {
  font-weight: 500;
  color: #333;
}

.booking-form :deep(.el-form-item.is-required .el-form-item__label:before) {
  content: '*';
  color: #f56c6c;
  margin-right: 4px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  gap: 20px;
  padding-top: 10px;
}

.dialog-footer .el-button {
  padding: 10px 30px;
  font-size: 14px;
}

.dialog-footer .el-button--primary {
  background: #4a90e2;
  border-color: #4a90e2;
}

.dialog-footer .el-button--primary:hover {
  background: #3a7bc8;
  border-color: #3a7bc8;
}
</style>
